export default "__VITE_ASSET__CTVM0NJ5__"